import React from "react";
import GameContainer from "../../../../../edu_lms/components/Game";
import ColorContainer from "../../../../../edu_lms/components/Game/Color/ColorContainer";

const FillColor = ({ activity, bookId, showResult }) => {
	return (
		<GameContainer data={activity}>
			<ColorContainer data={activity} objectId={bookId} showResult={showResult}/>
		</GameContainer>
	);
};

export default FillColor;
